namespace GeniuzPOS.InitialData {
    export class PsPriceOverrideReasonColumns {
        static columnsKey = 'InitialData.PsPriceOverrideReason';
    }
}
